import { observer } from 'mobx-react'
import './index.scss'
import { ReactComponent as Search } from '../../../../assets/footer/search.svg'
import { useEffect, useState } from 'react'
import SearchState, { searchArticles } from '../../../../stores/SearchState'
import GlobalState from '../../../../stores/GlobalState'
import SearchItem from '../SearchItem'
import classNames from 'classnames'
import ContentState from '../../../../stores/ContentState'

const SearchContent = observer(() => {
  const [value, setValue] = useState('')
  const [val, setVal] = useState('')
  const [width, setWidth] = useState(window.innerWidth)
  useEffect(() => {
    if (localStorage.getItem('search')) {
      const val = localStorage.getItem('search')
      if (val?.length) {
        setValue(val!)
        setVal(val)
        searchArticles(val, GlobalState.currentLocale.lang)
      }
    }
  }, [])
  const search = () => {
    searchArticles(value, GlobalState.currentLocale.lang).then(() => {
      setVal(value)
      setValue('')
    })
    if (width <= 768) {
      document.querySelector('.search-content__top-block .button.black')?.classList.add('button-active')
      setTimeout(() => {
        document
          .querySelector('.search-content__top-block .button.black')
          ?.classList.remove('button-active')
      }, 500)
    }
  }

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])
  if (!ContentState.search) return <></>
  const content: any = ContentState.search

  return (
    <section className="search-content">
      <div className="search-content__top">
        <div className="search-content__title">{content.title}</div>

        <div className="search-content__top-block">
          <div className="search-content__search">
            <Search />
            <input
              className="input"
              value={value}
              placeholder={content.placeholder}
              onChange={(e) => setValue(e.target.value)}
            />
          </div>
          <div className="button black" onClick={search}>
            {content.buttonText}
          </div>
        </div>
      </div>
      {!SearchState.searchRes?.length ? (
        <></>
      ) : (
        <div className="search-content__text">
          {content.resultTextStart} {SearchState.searchRes?.length}{' '}
          {SearchState.searchRes?.length > 1
            ? content.resultTextEndPlural
            : content.resultTextEndOne}
        </div>
      )}

      <div
        className={classNames(
          'search-content__list',
          !SearchState.searchRes?.length && 'empty',
        )}
      >
        {SearchState.searchRes?.length ? (
          SearchState.searchRes?.map((a, id) => (
            <SearchItem
              dt={a}
              key={id}
              number={id + 1}
              button={content.itemButton}
            />
          ))
        ) : (
          <div className="search-content__text center">
            {content.noresult.replaceAll('.', '')} "{val}"
          </div>
        )}
      </div>
    </section>
  )
})

export default SearchContent
